import React, {useEffect, useState} from 'react';
import SettingChartSingle from './SettingChartSingle';
import UserEdit from './UserEdit'; // Popup-Komponente importieren
import {useSelectedUserStore} from './SelectedUserStore'; // Zustand importieren
import api from '../../../api/axios';
import Cookies from 'js-cookie';

const itemsPerPage = 10;

const SettingChart = ({searchTerm}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [userdata, setUserData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const {setSelectedUser} = useSelectedUserStore(); // Zustand verwenden

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                const accessToken = Cookies.get('accessToken');
                if (!accessToken) {
                    throw new Error('Access Token fehlt. Bitte melden Sie sich erneut an.');
                }

                const response = await api.get('/api/v1/management/sitemanager', {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                const sortedData = response.data.sort((a, b) => {
                    const nameA = `${a.surname} ${a.forename}`.toLowerCase();
                    const nameB = `${b.surname} ${b.forename}`.toLowerCase();
                    return nameA.localeCompare(nameB);
                });

                setUserData(sortedData);
            } catch (err) {
                setError(err.message || 'Unbekannter Fehler');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const filteredUsers = userdata.filter(user =>
        `${user.forename} ${user.surname}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.id.toString().includes(searchTerm)
    );

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const displayedUsers = filteredUsers.slice(startIndex, endIndex);
    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

    return (
        <div className='flex flex-col w-full'>
            <div className='flex justify-between w-full py-2 font-bold border-b text-sm'>
                <div className='text-left flex-1'>Name</div>
                <div className='text-left flex-1'>E-Mail</div>
                <div className='text-left flex-1'>Standort</div>
                <div className='text-left flex-1'>Hapak-ID</div>
            </div>

            <div className='flex-1'>
                {displayedUsers.map((data, index) => (
                    <SettingChartSingle
                        key={data.id}
                        surAndLastName={`${data.forename} ${data.surname}`}
                        mail={data.email}
                        location={data.companySite}
                        hapakId={data.id}
                        onClick={() => setSelectedUser({hapakId: data.id})} // Benutzer setzen
                    />
                ))}
            </div>

            <div className='flex justify-center mt-4'>
                {Array.from({length: totalPages}, (_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentPage(index + 1)}
                        className={`ml-2 px-3 py-2 w-8 font-color-1 text-sm flex items-center text-center shadow-sm border border-color-2 rounded-lg font-medium ${currentPage === index + 1 ? '' : 'bg-color-5 font-color-2'}`}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>

            <UserEdit/> {/* Popup-Komponente */}
        </div>
    );
}

export default SettingChart;
